import localization, {Localization} from './Localization';
import {useLocalization} from './useLocalization';
export {Localization, useLocalization};
export default localization;
